export default __webpack_public_path__ + "static/media/join.da0fa81a.png";